const getDefaultState = () => {
  return {
    constructions: [],
    constructionSites: []
  }
};
const state = getDefaultState();

const getters = {
  getConstructions (state) {
    return state.constructions
  },
  getConstructionSites (state) {
    return state.constructionSites
  }
}

const mutations = {
  SET_CONSTRUCTIONS (state, payload) {
    state.constructions = payload;
  },
  SET_CONSTRUCTION_SITES (state, payload) {
    state.constructionSites = payload;
  },
};

export default {
  state, mutations, getters
};



// WEBPACK FOOTER //
// ./src/stores/modules/constructionStore.js